const scrollbarWidth = () => window.innerWidth - document.body.clientWidth;

export default scrollbarWidth;
